/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event){
    var mm = gsap.matchMedia();

    mm.add("(min-width: 1025px)", () => {
        // GSAP case study animations
        var csContainer = document.querySelector('.wp-block-create-block-mq20-case-study-slider');
        var csHeading = document.querySelector('.case-study-slide-header h2');
        var csHeadingAnimated = new SplitType(csHeading);
        var csParagraph = document.querySelector('.case-study-slide-header p');
        var csItemsContainer = document.querySelector(".case-study-slide-list");
        var csItems = gsap.utils.toArray(".case-study-slide-list .case-study-slide-item");

        function initCsScrollAnimation() {
            var csScrollAnimationTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: csContainer,
                    start: "top +=90%",
                    end: "bottom bottom"
                }
            });

            var headingAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut"
            };

            var itemAnimationProps = {
                y: 20,
                opacity: 0,
                duration: 0.2,
                ease: "power3.inOut",
                stagger: 0.2
            };

            gsap.fromTo(csHeadingAnimated.chars, {
                y: 20,
                opacity: 0
            }, {
                y: 0,
                opacity: 1,
                ease: "power3.inOut",
                stagger: 0.01,
                scrollTrigger: {
                    trigger: csContainer,
                    start: "top +=85%",
                    end: "bottom bottom"
                }
            });

            csScrollAnimationTimeline
                .from(csParagraph, {...headingAnimationProps, delay: 0.1})
                .from(csItems, itemAnimationProps);

            gsap.to(csItems, {
                xPercent: -100 * (csItems.length - 3),
                ease: "none",
                scrollTrigger: {
                    trigger: csItemsContainer,
                    start: "top +=10%",
                    end: "bottom +=5%",
                    pin: true,
                    scrub: 1
                }
            });
        }

        initCsScrollAnimation();
    });
});
